import { type ReactElement, type ReactNode } from "react";
import classes from "./PriceSummary.module.less";
import classNames from "classnames";

type EntryElement = ReactElement<EntryProps>;

type MaybeElement<T> = T | false | undefined | null;

interface PriceSummaryProps {
  children: MaybeElement<EntryElement> | MaybeElement<EntryElement>[];
  className?: string;
}
export const PriceSummary = ({ children, className }: PriceSummaryProps) => {
  return <div className={classNames(className, classes.root)}>{children}</div>;
};

interface EntryProps {
  title: ReactNode;
  children: ReactNode;

  bold?: boolean;

  variant?: "default" | "small";
}
const Entry = (props: EntryProps) => {
  return (
    <div
      className={classNames(
        classes.entry,
        props.bold && "f-bold",
        props.variant === "small" ? classes.small : classes.default
      )}
    >
      <div>{props.title}</div>
      <div className={classes.entryValue}>{props.children}</div>
    </div>
  );
};

PriceSummary.Entry = Entry;
